import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TRENDS_ESSENTIAL_BY_CATEGORY_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useTrendTerritories',
  name: 'Get trends essential by category',
  message: 'Error fetching trends essential by category',
}
